export class WCGroupLooserDataDto {
    line: number;
    count: number;
    groups: string[];
}